/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {useNavigate} from 'react-router-dom'
import {LineChart} from '../../../../components/Charts/LineChart/LineChart'
import {ApexOptions} from 'apexcharts'
import Chart from 'react-apexcharts'
import {GET, POST} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {floatToPrice} from '../../../../functions/price'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import moment from 'moment'
import {i18n} from '../../../../translate/i18n'
import styles from './index.module.css'
import {toMoney} from '../../../../utils/formater'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import useAuth from '../../../../hooks/useAuth'
import {calcPercent} from '../../../../utils/utils'

type FilterItemType = {
  id: number
  name: string
}

type SalesByCategoryType = {
  label: string
  value: number
}

type SalesByCustomerType = {
  idCustomer: number
  customerName: string
  orders: string
  carts: string
  total: string
}

type SalesSellerType = {
  labels: string[]
  values: number[]
}

type SelectType = {
  value: string | number
  label: string
}

const VendedorContent: FC = () => {
  const navigate = useNavigate()
  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')

  const [customers, setCustomers] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])
  const [categories, setCategories] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])
  const [products, setProducts] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])

  const [customerSelected, setCustomerSelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })
  const [productSelected, setProductSelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })
  const [categorySelected, setCategorySelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })

  const [salesByCategory, setSalesByCategory] = useState<SalesByCategoryType[]>([])

  const [sales, setSales] = useState(0)
  const [orders, setOrders] = useState(0)
  const [customersReport, setCustomersReport] = useState(0)
  const [carts, setCarts] = useState(0)
  const [conversion, setConversion] = useState(0)
  const [averageTicket, setAverageTicket] = useState(0)

  const [modeViewSale, setModeViewSale] = useState<'daily' | 'monthly'>('daily')
  const [salesSeller, setSalesSeller] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })

  const [modeViewSaleCart, setModeViewSaleCart] = useState<'daily' | 'monthly'>('daily')
  const [salesSellerCart, setSalesSellerCart] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })
  const [salesSellerLink, setSalesSellerLink] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })

  const [salesByCustomer, setSalesByCustomer] = useState<SalesByCustomerType[]>([])

  const [dateSearch, setDateSearch] = useState('custom')

  const [loading, setLoading] = useState(false)
  const {loginInfo} = useAuth()

  const optionsChart: ApexOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return 'R$' + value.toFixed(2).replace('.', ',')
        },
      },
    },
  }

  const filterSales = async (newStartDate?: string, newFinalDate?: string) => {
    try {
      const salesCategoryRes = await POST('/summaryManagementSeller/sellerCategory', {
        idSeller: loginInfo.id,
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
      })
      if (salesCategoryRes.data && salesCategoryRes.data.entities) {
        setSalesByCategory(
          salesCategoryRes.data.entities.map((entity: any) => ({
            label: entity.nameCategory,
            value: parseFloat(entity.Total),
          }))
        )
      } else {
        setSalesByCategory([])
      }

      const salesSellerRes = await POST('/summaryManagementSeller/sellerBilling', {
        idSeller: loginInfo.id,
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
      })
      if (salesSellerRes.data && salesSellerRes.data.entities && salesSellerRes.data.entities[0]) {
        const itemBilling = salesSellerRes.data.entities[0]
        setSales(parseFloat(itemBilling.total))
        setOrders(parseInt(itemBilling.orders))
        setCarts(parseFloat(itemBilling.carts))
        setConversion(calcPercent(parseFloat(itemBilling.total), parseFloat(itemBilling.carts)))
        setCustomersReport(parseInt(itemBilling.customers))
        setAverageTicket(parseFloat(itemBilling.average))
      } else {
        setSales(0)
        setOrders(0)
        setCustomersReport(0)
        setCarts(0)
        setConversion(0)
        setAverageTicket(0)
      }

      const salesCustomerRes = await POST('/summaryManagementSeller/sellerCustomer', {
        idSeller: loginInfo.id,
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
      })
      if (salesCustomerRes.data && salesCustomerRes.data.entities) {
        setSalesByCustomer(salesCustomerRes.data.entities)
      } else {
        setSalesByCustomer([])
      }

      const salesDateRes = await POST('/summaryManagementSeller/salesDate', {
        idSeller: loginInfo.id,
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
      })
      if (salesDateRes.data && salesDateRes.data.entities) {
        setSalesSeller({
          labels: salesDateRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateRes.data.entities.map((entity: any) => parseFloat(entity.total)),
        })
      } else {
        setSalesSeller({
          labels: [],
          values: [],
        })
      }

      const salesDateCartRes = await POST('/summaryManagementSeller/salesCart', {
        idSeller: loginInfo.id,
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
      })

      if (salesDateCartRes.data && salesDateCartRes.data.entities) {
        setSalesSellerCart({
          labels: salesDateCartRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateCartRes.data.entities.map((entity: any) => parseFloat(entity.carts)),
        })
        setSalesSellerLink({
          labels: salesDateCartRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateCartRes.data.entities.map((entity: any) => parseFloat(entity.links)),
        })
      } else {
        setSalesSellerCart({
          labels: [],
          values: [],
        })
        setSalesSellerLink({
          labels: [],
          values: [],
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getItems = async () => {
    try {
      setLoading(true)
      const filterItens = await GET('/summaryManagementSeller/infosToFilter')
      if (filterItens.data) {
        setCategories(
          filterItens.data.categories
            ? [...categories, ...filterItens.data.categories]
            : [{id: 0, name: 'Todos'}]
        )
        setProducts(
          filterItens.data.products
            ? [...products, ...filterItens.data.products]
            : [{id: 0, name: 'Todos'}]
        )
        setCustomers(
          filterItens.data.customers
            ? [...customers, ...filterItens.data.customers]
            : [{id: 0, name: 'Todos'}]
        )
      }
      await filterSales(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const verifyModeViewLabels = (sales: SalesSellerType, modeView: string) => {
    if (modeView === 'daily') {
      return sales.labels.map(
        (l) => l.split(' ')[0] + ' ' + i18n.t(`months.${l.split(' ')[1]}`) + ' ' + l.split(' ')[2]
      )
    } else {
      return organizeMonth(sales).labels.map(
        (l) => i18n.t(`months.${l.split(' ')[0]}`) + ' ' + l.split(' ')[1]
      )
    }
  }

  const verifyModeViewValues = (sales: SalesSellerType, modeView: string) => {
    if (modeView === 'daily') {
      return sales.values
    } else {
      return organizeMonth(sales).values
    }
  }

  const organizeMonth = (sales: SalesSellerType) => {
    const newSales: any = {}
    sales.labels.forEach((label, index) => {
      const labelSplit = label.split(' ')
      if (labelSplit.length >= 3) {
        const labelMonth = `${labelSplit[1]} ${labelSplit[2]}`
        if (newSales[labelMonth]) {
          newSales[labelMonth] += sales.values[index]
        } else {
          newSales[labelMonth] = sales.values[index]
        }
      }
    })
    const newSalesResult = Object.entries(newSales).map((sale: any) => ({
      labels: sale[0],
      values: Math.trunc(sale[1] * 100) / 100,
    }))
    return {
      labels: newSalesResult.map((sale) => sale.labels),
      values: newSalesResult.map((sale) => sale.values),
    }
  }

  const changeDateDifference = async (typeDate: string) => {
    setDateSearch(typeDate)
    const formatDate = (date: Date) => date.toISOString().split('T')[0]
    const currentDate = new Date()
    switch (typeDate) {
      case 'today':
        const newStartDate = moment().format('YYYY-MM-DD')
        const newFinalDate = moment().format('YYYY-MM-DD')
        setStartDate(newStartDate)
        setFinalDate(newFinalDate)

        setLoading(true)
        await filterSales(newStartDate, newFinalDate)
        setLoading(false)
        break
      case 'month':
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)

        setStartDate(formatDate(firstDayOfMonth))
        setFinalDate(formatDate(lastDayOfMonth))

        setLoading(true)
        await filterSales(formatDate(firstDayOfMonth), formatDate(lastDayOfMonth))
        setLoading(false)
        break
      case 'lastMonth':
        const firstDayOfLastMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          1
        )
        const lastDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0)

        setStartDate(formatDate(firstDayOfLastMonth))
        setFinalDate(formatDate(lastDayOfLastMonth))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastMonth), formatDate(lastDayOfLastMonth))
        setLoading(false)
        break
      case 'week':
        const firstDayOfWeek = new Date(currentDate)
        firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay())

        const lastDayOfWeek = new Date(currentDate)
        lastDayOfWeek.setDate(currentDate.getDate() + (6 - currentDate.getDay()))

        setStartDate(formatDate(firstDayOfWeek))
        setFinalDate(formatDate(lastDayOfWeek))

        setLoading(true)
        await filterSales(formatDate(firstDayOfWeek), formatDate(lastDayOfWeek))
        setLoading(false)
        break
      case 'lastWeek':
        const lastDayOfLastWeek = new Date(currentDate)
        lastDayOfLastWeek.setDate(currentDate.getDate() - currentDate.getDay() - 1)
        const firstDayOfLastWeek = new Date(lastDayOfLastWeek)
        firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6)
        setStartDate(formatDate(firstDayOfLastWeek))
        setFinalDate(formatDate(lastDayOfLastWeek))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastWeek), formatDate(lastDayOfLastWeek))
        setLoading(false)
        break
      case 'year':
        const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1)
        const lastDayOfYear = new Date(currentDate.getFullYear(), 11, 31)
        setStartDate(formatDate(firstDayOfYear))
        setFinalDate(formatDate(lastDayOfYear))

        setLoading(true)
        await filterSales(formatDate(firstDayOfYear), formatDate(lastDayOfYear))
        setLoading(false)
        break
      case 'lastYear':
        const firstDayOfLastYear = new Date(currentDate.getFullYear() - 1, 0, 1)
        const lastDayOfLastYear = new Date(currentDate.getFullYear() - 1, 11, 31)
        setStartDate(formatDate(firstDayOfLastYear))
        setFinalDate(formatDate(lastDayOfLastYear))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastYear), formatDate(lastDayOfLastYear))
        setLoading(false)
        break
    }
  }

  useEffect(() => {
    setStartDate(moment().format('YYYY-MM-DD'))
    setFinalDate(moment().format('YYYY-MM-DD'))
    getItems()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-body'>
                <div className={styles.filterItems}>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.customer`)}
                    options={customers.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={customerSelected}
                    change={(value: SelectType) => {
                      setCustomerSelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.categories`)}
                    options={categories.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={categorySelected}
                    change={(value: SelectType) => {
                      setCategorySelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.product`)}
                    options={products.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={productSelected}
                    change={(value: SelectType) => {
                      setProductSelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder=''
                    label=''
                    options={[
                      {
                        select: 'Hoje',
                        value: 'today',
                      },
                      {
                        select: 'Semana',
                        value: 'week',
                      },
                      {
                        select: 'Semana passada',
                        value: 'lastWeek',
                      },
                      {
                        select: 'Mês',
                        value: 'month',
                      },
                      {
                        select: 'Mês passado',
                        value: 'lastMonth',
                      },
                      {
                        select: 'Ano',
                        value: 'year',
                      },
                      {
                        select: 'Ano passado',
                        value: 'lastYear',
                      },
                      {
                        select: 'Customizado',
                        value: 'custom',
                      },
                    ]}
                    value={dateSearch}
                    change={(value: string) => {
                      changeDateDifference(value)
                    }}
                  />
                  <div className='d-flex gap-2 flex-row align-items-end'>
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      label='Defina as datas'
                      value={startDate}
                      maxLength={finalDate}
                      change={(value: string) => {
                        setDateSearch('custom')
                        setStartDate(value)
                      }}
                    />
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      label=''
                      value={finalDate}
                      change={(value: string) => {
                        setDateSearch('custom')
                        setFinalDate(value)
                      }}
                    />
                  </div>
                  <Button
                    color='primary'
                    icon='fa fa-filter'
                    text={i18n.t(`buttons.filter`)}
                    click={async () => {
                      setLoading(true)
                      await filterSales()
                      setLoading(false)
                    }}
                    btnClass='fw-bolder'
                    verticalPadding={3}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5 flex-wrap'>
            <div className='d-flex flex-row flex-wrap' style={{flex: 0.3}}>
              <div className='d-flex justify-content-between gap-5' style={{flex: 1}}>
                <div className='card mb-5 w-100'>
                  <div className='card-header'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`indicators.summary_seller`)}
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className={styles.cardsItems}>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.sales`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(sales.toFixed(2))}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.orders`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{orders}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.attended_customers`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{customersReport}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.carts`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(carts.toFixed(2))}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.sales_conversion`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{conversion}%</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.mean_ticket`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(averageTicket.toFixed(2))}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='card card-xxl-stretch' style={{flex: 0.7}}>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.seller_sales_by_category`)}
                  </span>
                </h3>
              </div>
              <div
                className={`d-flex ${
                  salesByCategory.length > 0 ? 'align-items-center' : 'align-items-start'
                } w-100 h-100 p-4`}
              >
                <div className='w-100'>
                  {salesByCategory && salesByCategory.length > 0 ? (
                    <Chart
                      options={{
                        plotOptions: {
                          pie: {
                            dataLabels: {
                              offset: 0,
                            },
                          },
                        },
                        labels: salesByCategory.map((sale) => sale.label),
                        legend: {
                          show: false,
                          horizontalAlign: 'right',
                          formatter: function (legendName, opts) {
                            return `${legendName}: R$${opts.w.config.series[opts.seriesIndex]}`
                          },
                        },
                        theme: {
                          monochrome: {
                            enabled: true,
                            color: '#CA498C',
                            shadeTo: 'light',
                            shadeIntensity: 0.65,
                          },
                        },

                        dataLabels: {
                          style: {
                            colors: ['#FFF'],
                            fontWeight: 'bold',
                          },
                          dropShadow: {
                            enabled: true,
                            opacity: 1,
                          },
                          formatter: function (val, opts) {
                            return `${opts.w.config.labels[opts.seriesIndex]}: ${floatToPrice(
                              opts.w.config.series[opts.seriesIndex]
                            )}`
                          },
                        },
                        tooltip: {
                          y: {
                            formatter: function (val, opts) {
                              return floatToPrice(opts.config.series[opts.seriesIndex])
                            },
                          },
                        },
                      }}
                      series={salesByCategory.map((sale) => sale.value)}
                      type='pie'
                      height={320}
                    />
                  ) : (
                    <p>Resultados não encontrados</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100 pt-4'>
              <div className='card-header'>
                <h3
                  className='card-title align-items-start flex-column'
                  style={{paddingBottom: '6em'}}
                >
                  <span className='card-label fw-bolder fs-3'>
                    {i18n.t(`indicators.sellers_invoice`)}
                  </span>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.select_view`)}
                    options={[
                      {
                        select: 'Diário',
                        value: 'daily',
                      },
                      {
                        select: 'Mensal',
                        value: 'monthly',
                      },
                    ]}
                    value={modeViewSale}
                    change={(value: 'daily' | 'monthly') => setModeViewSale(value)}
                  />
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      ...optionsChart,
                      xaxis: {
                        categories: verifyModeViewLabels(salesSeller, modeViewSale),
                      },
                    }}
                    series={[
                      {
                        name: 'Vendas',
                        data: verifyModeViewValues(salesSeller, modeViewSale),
                      },
                    ]}
                    type='line'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100 pt-4'>
              <div className='card-header'>
                <h3
                  className='card-title align-items-start flex-column'
                  style={{paddingBottom: '6em'}}
                >
                  <span className='card-label fw-bolder fs-3'>
                    {i18n.t(`indicators.comparative_sales_by_channel`)}
                  </span>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.select_view`)}
                    options={[
                      {
                        select: 'Diário',
                        value: 'daily',
                      },
                      {
                        select: 'Mensal',
                        value: 'monthly',
                      },
                    ]}
                    value={modeViewSaleCart}
                    change={(value: 'daily' | 'monthly') => setModeViewSaleCart(value)}
                  />
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      ...optionsChart,
                      xaxis: {
                        categories: verifyModeViewLabels(salesSellerCart, modeViewSaleCart),
                      },
                    }}
                    series={[
                      {
                        name: 'Carrinho gravado',
                        data: verifyModeViewValues(salesSellerCart, modeViewSaleCart),
                      },
                      {
                        name: 'Link do vendedor',
                        data: verifyModeViewValues(salesSellerLink, modeViewSaleCart),
                      },
                    ]}
                    type='line'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.sales_client`)}
                  </span>
                </h3>
              </div>
              <div className={`d-flex flex-column ${styles.tableSeller}`}>
                {salesByCustomer.length > 0 ? (
                  <>
                    <div className={`w-100 ${styles.gridSeller}`}>
                      <b>Cliente</b>
                      <b>Pedidos</b>
                      <b>Taxa de conversão</b>
                      <b>Faturamento</b>
                    </div>
                    {salesByCustomer.map((sale) => (
                      <div className={`w-100 ${styles.gridSeller}`}>
                        <p>
                          {sale.idCustomer} {sale.customerName}
                        </p>
                        <p>{sale.orders}</p>
                        <p>{calcPercent(parseInt(sale.orders), parseInt(sale.carts))}%</p>
                        <p>{toMoney(parseFloat(sale.total).toFixed(2))}</p>
                      </div>
                    ))}
                    <div className={`w-100 ${styles.gridSeller}`}>
                      <b>Total</b>
                      <p>{orders}</p>
                      <p>{conversion}%</p>
                      <p>{toMoney(sales.toFixed(2))}</p>
                    </div>
                  </>
                ) : (
                  <p>Resultados não encontrados</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const VendedorIndicadores: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Indicadores', path: 'indicadores/seller_access', isActive: false},
          {
            title: i18n.t(`indicators.sellerAccess`),
            path: 'indicadores/summary_access',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`indicators.sellerAccess`)}
      </PageTitle>
      <VendedorContent />
    </>
  )
}

export {VendedorIndicadores}
